import { ReactElement, ReactNode } from 'react';
import { Tile } from '@op/opds.opux';
import styles from './QuestionTile.module.scss';

interface QuestionProps {
  number: string;
  question: string | string[];
  children: ReactNode;
}

const QuestionTile = ({ number, question, children }: QuestionProps): ReactElement => {
  const lines = Array.isArray(question) ? question : [question];
  return (
    <Tile className={styles.tile}>
      <div className={styles.title}>{number}</div>
      <div className={styles.question}>
        {lines.map((line) => (
          <p key={line}>{line}</p>
        ))}
      </div>
      {children}
    </Tile>
  );
};

export default QuestionTile;
